import * as THREE from 'heritage/assets/three.module.js';

// One physical gold for both the making sequence and the laurel.
export function createGoldMaterial({polished=true,...options}={}){
  return new THREE.MeshPhysicalMaterial({
    color:0xf0b84b,metalness:1,roughness:polished?.115:.18,
    envMapIntensity:2.15,clearcoat:polished?.85:.65,
    transparent:true,side:THREE.DoubleSide,...options
  });
}